<script>
import {ref} from "vue";
import {routes} from "@/router";
import UiIcon from "@/components/UiIcon.vue";

export default {
  components: {UiIcon},
  props: ["modelValue"],
  emits: ["update:modelValue"],
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    }
  },
  setup() {


    const menuList = ref(
      routes
        .filter((e) => e.meta?.menuLabel)
        .map((e) => {
          if (e.meta?.menuLabel) {
            return {
              label: e.meta.menuLabel,
              link: e.path
            };
          }
        })
    );

    const getIconName = (routeLink, isActive) => {
      switch (routeLink) {
        case "/":
          return isActive ? "rectangles-blue" : "rectangles-light";
        case "/record":
          return isActive ? "sign-up-blue" : "sign-up-light";
        case "/future-visits":
          return isActive ? "planned-blue" : "planned-light";
        case "/history-visits":
          return isActive ? "history-blue" : "history-light";
        case "/labs":
          return isActive ? "research-blue" : "research-light";
        case "/docs":
          return isActive ? "documents-blue" : "documents-light";
        case "/profile/":
          return isActive ? "account-blue" : "account-light";
        default:
          break;
      }
    }

    return {
      menuList,
      getIconName
    };
  }
};
</script>

<template>
  <div class="left-navigation-drawer-container">
    <v-layout class="left-navigation-drawer" :class="{'left-navigation-drawer--active': value}">
      <v-navigation-drawer
        v-model="value"
        class="w-auto left-navigation-drawer-menu"
        :scrim="false"
      >
        <v-list>
          <v-list-item>
            <div class="d-flex justify-space-between align-center">
              <router-link to="/">
                <v-btn variant="text" class="pa-0 font-weight-bold">
                  <template #prepend>
                    <ui-icon name="building" :size="32"></ui-icon>
                  </template>
                  ЛК МСЧ70
                </v-btn>
              </router-link>

              <v-btn icon :size="32" @click="value = false" variant="text" class="pa-0">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>

          </v-list-item>
          <v-list-item
            v-for="item in menuList"
            :key="item.link"
            :to="item.link"
            :title="item.label"
          >
            <template #prepend="{isActive}">
              <ui-icon :name="getIconName(item.link, isActive)" :size="32" class="mr-2"></ui-icon>
            </template>
          </v-list-item>
          <v-list-item
            title="Профиль"
            to="/profile/"
          >
            <template #prepend="{isActive}">
              <ui-icon :name="getIconName('/profile/', isActive)" :size="32" class="mr-2"></ui-icon>
            </template>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-layout>
  </div>
</template>

<style scoped>
.left-navigation-drawer-container {
  min-height: 100vh
}

.left-navigation-drawer {
  transition: all .2s ease-in-out;
}

.left-navigation-drawer--active {
  margin-right: 300px;
}

.left-navigation-drawer--active .left-navigation-drawer-menu {
  left: 0 !important;
}

.left-navigation-drawer-menu {
  left: -45px !important;
  width: auto !important;
}

.v-navigation-drawer {
  background: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
  color: rgb(var(--v-theme-surface));
}

:deep(.v-list-item-title) {
  font-weight: bold;
}

.v-navigation-drawer--temporary.v-navigation-drawer--active {
  box-shadow: none;
}

:deep(.v-btn__prepend) {
  margin: 0;
  margin-right: 8px;
}

</style>
